import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Organization } from '../organizations/organization';
import { ObjectCache } from '../Models/objectCache.model';
import { Observable } from 'rxjs';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { PreferencesService } from './preferences.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService extends DataService<Organization> {
  constructor(private db: AngularFireDatabase, private ps: PreferencesService) {
    super(db, `entities/${ps.getLocationCode()}/Data/en/Organizations`, new ObjectCache<Organization>());
  }

  getCachedOrganizations(lang?: string): Organization[] {
    return super.getCachedObjects(lang);
  }

  async getSingleOrganization(id: string, lang?: string): Promise<Organization> {
    let path = this.PATH + '/' + id;
    if (lang) {
      path = path.replace('/en/', `/${lang}/`);
    }
    const result = await super.getRawDataFromPath(path);
    let results: Organization;
    results = result;
    return results;
  }

  getOrganizationById(id: string, lang?: string): Observable<Organization> {
    return super.getObjectById(id, lang);
  }

  getUpdatableOrganizations(lang?: string): AngularFireList<Organization> {
    return super.getAngularFireObjects(lang);
  }

  getOrganizations(lang?: string): Observable<Organization[]> {
    return super.getObjects(lang);
  }

  async findOrganizations(lang?: string): Promise<Organization[]> {
    return await super.findCollection(lang);
  }

  async findOrganization(id: string, lang?: string): Promise<Organization> {
    return await super.findDocument(id, lang);
  }
}
